// @vue/component
export default {
    name: 'Mybidding',

    components: {},

    mixins: [],

    props: {},

    data() {
        return {
            fullAllscreenLoading: false,
            form: {
                keyword: '',
                AuctionStatus: '',
                WinTypeStatus: ''
            },
            StatusList: [
                {
                    value: 'Executing',
                    label: '招标进行中'
                },
                {
                    value: 'Down',
                    label: '已结束'
                }
            ],
            ResultList: [
                {
                    value: -1,
                    label: '未投标'
                },
              {
                    value: 1,
                    label: '未中标'
                },
                {
                    value: 2,
                    label: '已中标'
                },
                {
                    value: 3,
                    label: '公示中'
                }
            ],
            Auctions: [

            ],//我参与的竞拍数组
            empty: false,//判断当竞拍为空的时候的展示
            pageSize: 15,
            currentPage: 1,
            pageSizes: [15, 50, 100],
            TotalCount: 0,
            url: {
              GetPagingMyAuction:SZH.assets.api + '/Auction/GetPagingMyAuction',
            }
        }
    },

    computed: {},

    watch: {},

    created() {
    },

    methods: {
      getPic(item) {
        if (item.F_ProductImgUrl) {
          return SZH.assets.image + "/" + item.F_ProductImgUrl;
        } else {
          return "";
        }
      },
      goDetail(item){
        this.$router.push({
          path: '/menu/AuctionHallDetail',
          query:{ id: item.F_Id}
        });
      },
        Search() {
            let self = this;
            self.fullAllscreenLoading = true;
            self.$http.post(self.url.GetPagingMyAuction, {
                Data: self.form,
                PageSize: self.pageSize,
                PageIndex: self.currentPage
            }).then(result => {
                if (result.state == true && result.data.Data && result.data.Data.length > 0) {
                    self.Auctions = result.data.Data;
                    self.TotalCount = result.data.TotalCount;
                    self.empty = false
                } else {
                    self.Auctions = [];
                    self.empty = true;
                    self.$message.error(result.message?result.message:'未查到数据');
                }
                self.fullAllscreenLoading = false;
            }, () => {
                self.fullAllscreenLoading = false;
            })
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.Search()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.Search()
        }

    },
    mounted() {
        this.Search()
    }
}



// WEBPACK FOOTER //
// ./src/views/Me/MyBidding/MyBidding.js